import { useSelector } from "react-redux";

import { Modal } from "@/components/General/Modal/modal";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as CustomerModule from "@/redux/modules/api/data/customer/customer.module";
import * as CustomerSelectors from "@/redux/modules/api/data/customer/customer.selectors";
import { broadcastMessage } from "@/redux/modules/value/messages/messages.utils";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";

import EditPasswordForm from "./editPassword.component";

const FORM_ID = "profileEditPasswordForm";

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

const EditPasswordModal = ({ onClose, isOpen }: Props) => {
    const { t } = useGranite();
    const isLoading = useSelector(CustomerSelectors.isLoading);
    const dispatch = useThunkDispatch();

    const onSubmit = (oldPassword: string, newPassword: string) => {
        dispatch(CustomerModule.changePassword(oldPassword, newPassword)).then(
            (action) => {
                if (action.type === CustomerModule.APIStatus.SUCCESS) {
                    onClose?.();
                    dispatch(CustomerModule.logout()).then((action) => {
                        if (action.type === CustomerModule.APIStatus.SUCCESS) {
                            location.assign(
                                `${Config.pages.login}?passwordupdated=true`
                            );
                        }
                    });
                } else {
                    broadcastMessage({
                        id: "edit-password-failure",
                        text: t(`general.profile.editpassword.modal.failure`),
                        status: "danger",
                        dismissible: false
                    });
                }
            }
        );
    };

    return (
        <Modal
            open={isOpen}
            setOpen={() => onClose?.()}
            formId={FORM_ID}
            confirmButtonColor="success"
            confirmButtonText={t("general.profile.editpassword.modal.submit")}
            isLoading={isLoading}
            title={t("general.profile.editpassword.modal.title")}
            subtitle={t("general.profile.editpassword.modal.subtitle")}
        >
            <EditPasswordForm onSubmit={onSubmit} />
        </Modal>
    );
};

export default EditPasswordModal;
